var _rect, _circle, _g, _g2, _g3, _g4, _g5, _g6, _g7, _rect2, _rect3, _g8, _g9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 789,
    viewBox: "0 0 1440 789",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1159_57356",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 789
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 789,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1159_57356)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    filter: "url(#filter0_f_1159_57356)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1031,
    cy: 390,
    r: 196,
    fill: "#50FF47"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1159_57356)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1465.5,
    cy: -136,
    rx: 463.5,
    ry: 464,
    fill: "#00FFBA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1159_57356)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2039.47,
    y: -579.044,
    width: 935.992,
    height: 935.992,
    rx: 200,
    transform: "rotate(94.1712 2039.47 -579.044)",
    fill: "url(#paint0_radial_1159_57356)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2038.4,
    y: -578.12,
    width: 933.992,
    height: 933.992,
    rx: 199,
    transform: "rotate(94.1712 2038.4 -578.12)",
    stroke: "url(#paint1_linear_1159_57356)",
    strokeWidth: 2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1159_57356)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -75.5,
    cy: 794,
    rx: 463.5,
    ry: 464,
    fill: "#00705B"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1159_57356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2365.26 258.908C2446.19 334.084 2450.85 460.631 2375.68 541.559L2010.89 934.262C1935.71 1015.19 1809.16 1019.85 1728.24 944.676L1335.53 579.886C1254.61 504.71 1249.94 378.163 1325.12 297.235L1689.91 -95.4674C1765.08 -176.395 1891.63 -181.058 1972.56 -105.882L2365.26 258.908Z",
    fill: "url(#paint2_linear_1159_57356)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2364.58 259.641C2445.1 334.441 2449.74 460.355 2374.94 540.879L2010.15 933.581C1935.35 1014.1 1809.44 1018.74 1728.92 943.944L1336.21 579.153C1255.69 504.353 1251.05 378.439 1325.85 297.916L1690.64 -94.7868C1765.44 -175.31 1891.36 -179.95 1971.88 -105.15L2364.58 259.641Z",
    stroke: "url(#paint3_linear_1159_57356)",
    strokeWidth: 2
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_1159_57356)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: -197.919,
    width: 935.992,
    height: 935.992,
    rx: 200,
    transform: "rotate(-15.4332 70 -197.919)",
    fill: "url(#paint4_linear_1159_57356)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.2301,
    y: -197.221,
    width: 933.992,
    height: 933.992,
    rx: 199,
    transform: "rotate(-15.4332 71.2301 -197.221)",
    stroke: "url(#paint5_linear_1159_57356)",
    strokeWidth: 2
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_1159_57356)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 669.379,
    y: 1568.84,
    width: 935.992,
    height: 935.992,
    rx: 200,
    transform: "rotate(-108.913 669.379 1568.84)",
    fill: "url(#paint6_linear_1159_57356)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670.001,
    y: 1567.57,
    width: 933.992,
    height: 933.992,
    rx: 199,
    transform: "rotate(-108.913 670.001 1567.57)",
    stroke: "url(#paint7_linear_1159_57356)",
    strokeWidth: 2
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_1159_57356)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 514,
    y: 840.279,
    width: 1028.39,
    height: 1028.39,
    rx: 200,
    transform: "rotate(-21.4625 514 840.279)",
    fill: "url(#paint8_linear_1159_57356)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515.297,
    y: 840.844,
    width: 1026.39,
    height: 1026.39,
    rx: 199,
    transform: "rotate(-21.4625 515.297 840.844)",
    stroke: "url(#paint9_linear_1159_57356)",
    strokeWidth: 2
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -128.281,
    y: 372.103,
    width: 1026.39,
    height: 1026.39,
    rx: 199,
    transform: "rotate(6.29919 -128.281 372.103)",
    fill: "url(#paint10_linear_1159_57356)",
    stroke: "url(#paint11_linear_1159_57356)",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -47.86,
    y: -361.889,
    width: 933.992,
    height: 933.992,
    rx: 199,
    transform: "rotate(6.81107 -47.86 -361.889)",
    fill: "url(#paint12_linear_1159_57356)",
    stroke: "url(#paint13_linear_1159_57356)",
    strokeWidth: 2
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_1159_57356)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -96,
    cy: 536,
    r: 216,
    fill: "#051211"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_1159_57356)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1403.56,
    cy: 767.848,
    rx: 326,
    ry: 195.118,
    transform: "rotate(-35.7614 1403.56 767.848)",
    fill: "#075B49"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1159_57356",
    x: 635,
    y: -6.00024,
    width: 792,
    height: 792,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_1159_57356"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1159_57356",
    x: 402,
    y: -1200,
    width: 2127,
    height: 2128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 300,
    result: "effect1_foregroundBlur_1159_57356"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1159_57356",
    x: 1031.88,
    y: -653.116,
    width: 1013.58,
    height: 1013.58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_1159_57356"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1159_57356",
    x: -1139,
    y: -270,
    width: 2127,
    height: 2128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 300,
    result: "effect1_foregroundBlur_1159_57356"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1159_57356",
    x: 1256.65,
    y: -174.35,
    width: 1187.49,
    height: 1187.49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_1159_57356"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_1159_57356",
    x: 80.9607,
    y: -436.04,
    width: 1129.4,
    height: 1129.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5,
    result: "effect1_foregroundBlur_1159_57356"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_1159_57356",
    x: 384.973,
    y: 398.973,
    width: 1150.89,
    height: 1150.89,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5,
    result: "effect1_foregroundBlur_1159_57356"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_1159_57356",
    x: 563.256,
    y: 513.256,
    width: 1234.84,
    height: 1234.84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_1159_57356"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_1159_57356",
    x: -412,
    y: 220,
    width: 632,
    height: 632,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_1159_57356"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_1159_57356",
    x: 965.426,
    y: 370.121,
    width: 876.277,
    height: 795.454,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_1159_57356"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1159_57356",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2619.19 42.5596) rotate(35.1622) scale(396.724)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.075,
    stopColor: "#050D11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#089272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#08A76F",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FFDFF",
    stopOpacity: 0.68
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1159_57356",
    x1: 2232.67,
    y1: 52.5997,
    x2: 3007,
    y2: 138.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72F5DF",
    stopOpacity: 0.18
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1159_57356",
    x1: 1920.73,
    y1: 224.932,
    x2: 1331.32,
    y2: 408.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.075,
    stopColor: "#050B11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#089261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08A76A",
    stopOpacity: 0.68
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1159_57356",
    x1: 1917.52,
    y1: 106.686,
    x2: 1327.94,
    y2: 615.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72F5CC",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1159_57356",
    x1: 347.649,
    y1: 350.896,
    x2: 883.596,
    y2: 657.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.075,
    stopColor: "#051011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#08926D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08A775",
    stopOpacity: 0.68
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1159_57356",
    x1: 263.199,
    y1: 433.725,
    x2: 1037.53,
    y2: 519.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FA877"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1159_57356",
    x1: 947.028,
    y1: 2117.65,
    x2: 1482.97,
    y2: 2424.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.075,
    stopColor: "#050B11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#089272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08A76A",
    stopOpacity: 0.68
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1159_57356",
    x1: 862.578,
    y1: 2200.48,
    x2: 1636.91,
    y2: 2285.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FA877"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1159_57356",
    x1: 1115.18,
    y1: 1243.42,
    x2: 1141.46,
    y2: 914.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.075,
    stopColor: "#050811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663677,
    stopColor: "#078679"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08A782",
    stopOpacity: 0.58
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1159_57356",
    x1: 863.727,
    y1: 1507.21,
    x2: 1188.43,
    y2: 975.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72F5DD",
    stopOpacity: 0.28
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1159_57356",
    x1: 447.532,
    y1: 745.627,
    x2: 880.833,
    y2: 545.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.075,
    stopColor: "#050911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#5AEABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71EFC3",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1159_57356",
    x1: 633.826,
    y1: 792.467,
    x2: 697.39,
    y2: 315.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#229E81",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72F5E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1159_57356",
    x1: 228.914,
    y1: 185.814,
    x2: 764.861,
    y2: 492.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.075,
    stopColor: "#050711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#37D0B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2CF2B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1159_57356",
    x1: 373.814,
    y1: 244.334,
    x2: 872.361,
    y2: 484.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005532",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72F5A6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.93581d3a2456915ebb17b790b0a61457.svg";
export { ForwardRef as ReactComponent };